<template>
  <div class="page-header navbar navbar-fixed-top">
    <div class="page-header-inner">
      <div class="page-logo">
        <a href="/">
          <img src="/static/admin/images/logo.png" class="logo-default" alt="alt">
        </a>
        <div class="menu-toggler sidebar-toggler">
        </div>
      </div>
      <a href="javascript:void(0);" class="menu-toggler responsive-toggler" data-toggle="collapse"
         data-target=".navbar-collapse">
      </a>
      <div class="page-top">
        <form class="search-form search-form-expanded" action="#" method="GET">
          <h2 style="font-weight:400;color: #fff;margin-left:10px" class="">B1G1 Admin System</h2>
        </form>
        <div class="top-menu">
          <ul class="nav navbar-nav pull-right">
            <li class="dropdown">
              <div class="input-icon right" style="margin-top: 18px !important;margin-left:15px">
                <i class="fa fa-search"></i>
                <input type="text" v-model="global_user_search" class="form-control input-large"
                       placeholder="Quick Search (UID, CID, BUSINESS NAME)..." name="global_user_search"
                       id="global_user_search" autocomplete="off">
                <div id="global_user_search_data" v-if="userDetails && is_display_userData">
                  <ul class="user_sub-menu">
                    <li v-for="user_item in userDetails.data" v-bind:key="user_item">
                      <a :href="host + '/admin/users/display/' + user_item.id" class="">
                        <h4><p>{{user_item.first_name}} {{user_item.last_name}}</p></h4>
                        <p v-if="user_item.user_business.company"><span>{{ user_item.user_business.company.company_name }} </span>
                        </p>
                        <p>{{ user_item.email }} </p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="dropdown" id="header_inbox_bar">
              <a href="#" class="" style="margin: 0px;padding: 28px 16px 19px 16px;">
                <i class="icon-envelope-open" style="font-size: 18px;color: #fff"></i>
                <span class="badge badge-default" id="message_unread_total"
                      style="display:none;background-color: #00b4eb; color: #ffffff;position: absolute;  top: 17px;  right: 9px;  font-weight: 300;  padding: 3px 6px;">
                                0 </span>
              </a>

            </li>
            <li class="dropdown dropdown-user">
              <a href="javascript:void(0);" class="dropdown-toggle">
                            <span class="username username-hide-on-mobile">
                                Welcome, {{user.first_name}} </span>
              </a>
            </li>
            <li class="dropdown  dropdown-user" v-if="user.change_type==1">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="showDropDown = !showDropDown">
                <span class="username">Switch to </span><span class="caret"></span>
              </a>
              <ul class="dropdown-menu" v-if="showDropDown">
                <li><a @click="switchToBusiness()">Business Account</a></li>
                <li><a @click="switchToWCU()">Partner Account</a></li>
              </ul>
            </li>
            <li class=" dropdown-user">
              <a @click="logout()" class="dropdown-toggle">
                <i class="fa fa-sign-out"></i>
                <span class="username username-hide-on-mobile">
                                Logout </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '../../api/user'
import config from '../../config/app'

export default {
  data () {
    return {
      user: this.$store.getters.currentUser,
      showDropDown: false,
      global_user_search: null,
      userDetails: null,
      host: config.host,
      is_display_userData: false,
      filter: {
        keyword: null
      }
    }
  },
  methods: {
    switchToWCU () {
      userApi.changeToPartner().then((response) => {
        if (response === true) {
          this.$store.dispatch('changeTypeToPartner')
          this.$router.push('/')
        }
      })
    },
    switchToBusiness () {
      userApi.changeToBusiness().then((response) => {
        if (response === true) {
          this.$store.dispatch('changeTypeToBusiness')
          this.$router.push('/')
        }
      })
    },
    logout () {
      if (localStorage.getItem('login_user_type')) {
        localStorage.removeItem('login_user_type')
        localStorage.removeItem('login_user_name')
        localStorage.removeItem('login_user_password')
      }
      this.$store.dispatch('logout')
      this.$router.push({name: 'home'})
    },
    fastUserSearch (key) {
      if (key) {
        this.filter = {
          keyword: key
        }
        let query = {}
        Object.assign(query, this.filter)
        userApi.searchData(query, ['UserRole', 'UserBusiness', 'UserBusiness.Company', 'UserBusiness.Country']).then((response) => {
          this.userDetails = response
        })
      }
    }
  },
  watch: {
    global_user_search: {
      handler: function (val, oldVal) {
        if (val) {
          this.is_display_userData = true
          this.fastUserSearch(val)
        } else {
          this.is_display_userData = false
        }
      }
    }
  }
}
</script>

<style scoped>
  .dropdown-toggle,
  .dropdown-menu {
    display: block !important;
  }

  #global_user_search_data {
    background: #fff;
    border: 1px solid #0096d7;
  }

  #global_user_search_data ul {
    padding: 0px;
    list-style: none;
  }

  #global_user_search_data li {
    border-bottom: 1px solid #0096d7;
    padding: 10px;
  }

  #global_user_search_data li:last-child {
    border: none;
  }

  #global_user_search_data p {
    margin: 0;
  }

  #global_user_search_data h4 {
    margin: 0;
    color: #000;
    text-decoration: none !important;
    font-weight: bold;
  }

  #global_user_search_data span {
    margin: 0;
    color: #000;
    text-decoration: none !important;
  }

  .user_sub-menu li a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Header.vue